import React, { Component } from "react";
import LeadsCardContainerNew from "../leadsCardNew";
import "./index.scss";
import QuestionnaireIcon from "../Questionnaire";

const EXPIRATION_DURATION_MS = 24 * 60 * 60 * 1000;

const setItemWithExpiration = (key, value) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + EXPIRATION_DURATION_MS,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

const getItemWithExpiration = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLeadsCard: false,
    };
  }

  componentDidMount() {
    const closeLeadsCard = getItemWithExpiration("closeLeadsCard");
    if (!closeLeadsCard) {
      this.setState({ showLeadsCard: true });
    }
  }

  handleLeadsCardClose = () => {
    this.setState({ showLeadsCard: false });
    setItemWithExpiration("closeLeadsCard", true);
  };

  handleOpenLeadsCard = () => {
    this.setState({ showLeadsCard: true });
    localStorage.removeItem("closeLeadsCard");
  };

  render() {
    const { showLeadsCard } = this.state;

    return (
      <div className="sidebar-container">
        <div className="sidebar-leads-card-icon" onClick={this.handleOpenLeadsCard}>
          <img
            className="sidebar-leads-card-icon-img"
            src="https://img.alicdn.com/imgextra/i4/O1CN01EovnQz27768t4lmBx_!!6000000007749-2-tps-64-64.png"
            alt="采购助手"
          />
          <div className="sidebar-leads-card-icon-title">采购助手</div>
        </div>
        <QuestionnaireIcon />

        {showLeadsCard && <LeadsCardContainerNew onClose={this.handleLeadsCardClose} className="sidebar-leads-card-container" />}
      </div>
    );
  }
}
